import { ReactNode } from 'react';
import { useStatusCode } from '@universal/lib/StatusCodeContext';

// Types
interface Props {
  code: number;
  children: ReactNode;
}

export const HttpStatus = ({ children, code }: Props): ReactNode => {
  const setStatusCode = useStatusCode();
  if (code) setStatusCode(code);
  return children;
};
